export default "__VITE_ASSET__DMKEDqB___"